import * as companyBillService from "../../../services/companyBill";
import * as customerBillService from "../../../services/customerBill";
import * as settings from "../../../services/settings";

import { Button, Col, Form, Image, Modal, Row, Spin, Upload, message, notification } from "antd";
import { ImagePreview, UploadButton, createHandlePreview, createHandleUpload } from "../../../utils/uploadUtils.jsx";
import { useEffect, useState } from "react";

import { useAccessToken } from "../../../contexts/AccessTokenContext";

export const ModalCreateImages = ({
  isCompanyBill,
  isOpen,
  setIsOpen,
  handleCancel,
  handleOk,
  companyBillItemId,
  onSearch,
}) => {
  const { accessToken } = useAccessToken();
  const [loading, setLoading] = useState(false);
  const [api, contextHolder] = notification.useNotification();
  const [messageApi, contextMessage] = message.useMessage();
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState("");
  const [fileList, setFileList] = useState([]);
  const [form] = Form.useForm();

  const openNotificationWithIcon = (type, message, description) => {
    api[type]({
      message: message,
      description: description,
    });
  };

  const handleUpload = createHandleUpload(messageApi);
  const handlePreview = createHandlePreview(setPreviewImage, setPreviewOpen);

  const handleChange = ({ fileList: newFileList }) => {
    setFileList(newFileList);
  };

  const uploadButton = <UploadButton />;

  const onSubmit = async () => {
    const formData = new FormData();
    const old_images = [];

    if (fileList.length > 0) {
      fileList.forEach((file) => {
        if (file.originFileObj) {
          formData.append("file", file.originFileObj);
        }
      });

      formData.append("old_images", JSON.stringify(old_images));

      setLoading(true);

      try {
        let response = null;

        if (isCompanyBill) {
          formData.append("company_bill_id", companyBillItemId);
          response = await companyBillService.createCompanyBillImage(accessToken, formData);
        } else {
          formData.append("customer_bill_id", companyBillItemId);
          response = await customerBillService.createCustomerBillImage(accessToken, formData);
        }

        if (response) {
          openNotificationWithIcon(settings.NotificationType.SUCCESS, "Success.", "Create Image success");
          setLoading(false);
          setIsOpen(false);
          onSearch({ company_bill_id: companyBillItemId });
        }
      } catch (err) {
        const { message } = settings.getErrorMessage(err);
        openNotificationWithIcon(settings.NotificationType.ERROR, "ERROR.", `${message}`);
        console.error("[ModalCreateImages] onSubmit: ", err);
        setLoading(false);
      }
    }
  };

  useEffect(() => {
    setLoading(true);
    if (!accessToken) return;
    setLoading(false);
  }, [accessToken]);

  return (
    <>
      <>
        {contextMessage}
        {contextHolder}
        <Modal
          title={"Create Bill Image"}
          open={isOpen}
          className="rounded-lg border-2"
          closable={true}
          centered={true}
          onCancel={handleCancel}
          footer={() => (
            <>
              <Button type="primary" onClick={onSubmit}>
                {"Save"}
              </Button>
              <Button onClick={handleCancel}>{"Cancel"}</Button>
            </>
          )}
        >
          <Spin spinning={loading}>
            <Row>
              <Col span={24}>
                <Form
                  form={form}
                  labelCol={{
                    flex: "130px",
                  }}
                >
                  <Upload
                    customRequest={handleUpload}
                    listType="picture-card"
                    fileList={fileList}
                    onPreview={handlePreview}
                    onChange={handleChange}
                  >
                    {uploadButton}
                  </Upload>
                  <ImagePreview
                    previewImage={previewImage}
                    previewOpen={previewOpen}
                    setPreviewOpen={setPreviewOpen}
                    setPreviewImage={setPreviewImage}
                    Image={Image}
                  />
                </Form>
              </Col>
            </Row>
          </Spin>
        </Modal>
      </>
    </>
  );
};
